import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
// eslint-disable-next-line no-unused-vars
import slickcss from 'slick-carousel/slick/slick.css';
import AdCaller from 'helpers/ads/adCaller';
import Loader from 'components/Loader';
import ErrorBoundary from 'components/ErrorBoundary';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import WithMiniTv from 'modules/WithMiniTv/WithMiniTv';
import ElectionStatusCard from '../ElectionStatusCard';
import s from './ElectionWrapper.scss';
import AlliancePopup from '../../common/AlliancePopup';
import LiveblogUpdates from '../../common/LiveblogUpdates/LiveblogUpdates';
import { loadElectionData } from '../../redux';
import analyticsWrapper from '../../../../helpers/analytics/analyticsWrapper';
import MainHeader from '../../common/MainHeader/MainHeader';
import LinksList from '../../../../components_v2/desktop/LinksList/LinksList';
import LinksListMobile from '../../../../components_v2/mobile/LinksList/LinksList';
import CapsuleTabList, {
  getSubsetByIndex,
} from '../../common/CapsuleTabList/CapsuleTabList';
// import Morebtn from '../../../../components_v2/desktop/Morebtn';

class ElectionWrapper extends React.Component {
  constructor(props) {
    super(props);
    try {
      const { states = [] } = this.props;
      this.state = {
        showAlliancePopup: false,
      };
      this.tabRefs = states.reduce((acc, tab) => {
        acc[tab.key] = React.createRef();
        return acc;
      }, {});
    } catch (error) {
      // Error Occurred
    }
  }

  componentDidMount() {
    const { isExitPoll } = this.props;
    if (!isExitPoll) {
      this.props.fetchElectionData({
        refreshinterval: this.props.refreshinterval,
        result: this.props.result,
        displaytext: this.props.displaytext,
        path: this.props.path,
        hideexitheading: this.props.hideexitheading,
        datasource: this.props.datasource,
        keywords: this.props.keywords,
        breakingnews: this.props.breakingnews,
        states: this.props.states,
        liveblog: this.props.liveblog,
        shareTitle: this.props.shareTitle,
        inpageminitv: this.props.inpageminitv,
        threeDViewBanner: this.props.threeDViewBanner,
      });
      this.refreshData();
    }
  }

  refreshData = () => {
    const { refreshinterval } = this.props;
    if (refreshinterval) {
      this.electionWidgetInterval = setInterval(() => {
        this.props.fetchElectionData({
          refreshinterval: this.props.refreshinterval,
          result: this.props.result,
          displaytext: this.props.displaytext,
          path: this.props.path,
          hideexitheading: this.props.hideexitheading,
          datasource: this.props.datasource,
          keywords: this.props.keywords,
          breakingnews: this.props.breakingnews,
          states: this.props.states,
          liveblog: this.props.liveblog,
          shareTitle: this.props.shareTitle,
          inpageminitv: this.props.inpageminitv,
          threeDViewBanner: this.props.threeDViewBanner,
        });
      }, refreshinterval * 1000);
    }
  };

  componentWillUnmount() {
    clearInterval(this.electionWidgetInterval);
  }

  setAlliancePopUpData = data => {
    this.setState({
      allianceMap: data,
      showAlliancePopup: !this.state.showAlliancePopup,
    });
    document.body.classList.toggle('disable-scroll');
  };

  toggleAllianceInfoPopup = () => {
    this.setState({ showAlliancePopup: !this.state.showAlliancePopup });
    document.body.classList.toggle('disable-scroll');
  };

  changeTabs = (item, fireEvent = true) => {
    this.setState({ activeTabObject: item }, () => {
      // eslint-disable-next-line no-unused-expressions
      typeof this.props.synctab === 'function' &&
        this.props.synctab(this.state.activeTabObject);
    });
    if (
      item &&
      Array.isArray(item) &&
      item.length &&
      item[0]?.key &&
      this.props.isWapView &&
      this.tabRefs?.[item[0].key]
    ) {
      this.tabRefs[item[0].key].current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }

    if (item && Array.isArray(item) && item.length && fireEvent) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'exitpoll_widget',
        category: 'tab_change',
        label: item.map(i => i.name).join('_') || 'Assembly Elections',
      });
    }
  };

  renderElectionstate = () => {
    const { allianceMap, showAlliancePopup } = this.state;
    let { activeTabObject } = this.state;
    const {
      hideBattle,
      hideStarCandidate,
      hideLiveblog,
      isWapView,
      hideETheading,
      hideLink,
      hideHeading,
      hideSharing,
      wgtclient,
      states = [],
      isExitPoll,
      electionData,
      sortedData,
      starCandidateData,
      electionwdtWap,
      hideTitleBar,
      // path,
      threeDViewBanner,
      page,
    } = this.props;

    if (!activeTabObject && !isWapView) {
      activeTabObject = states.slice(0, 3);
    } else if (!activeTabObject && isWapView) {
      activeTabObject = states.slice(0, 1);
    }
    const currentActiveTab = activeTabObject;
    const slideIndex =
      states instanceof Array &&
      states.findIndex(
        st =>
          typeof st !== 'undefined' &&
          currentActiveTab &&
          Array.isArray(currentActiveTab) &&
          currentActiveTab.length > 0 &&
          st.key === currentActiveTab[0].key,
      );
    if (slideIndex > -1 && this.slider) {
      this.slider.slickGoTo(slideIndex);
    }

    if (
      !electionData ||
      typeof electionData !== 'object' ||
      (electionData && Object.keys(electionData).length === 0)
    ) {
      return (
        <div className={s.stateLoading}>
          <Loader />
        </div>
      );
    }
    let slidesToShow = 1;
    let slidesToScroll = 1;
    if (!isWapView && states && Array.isArray(states) && states.length) {
      slidesToShow = states.length >= 3 ? 3 : states.length;
      slidesToScroll = states.length >= 3 ? 3 : states.length;
    }
    const settings = {
      slidesToShow,
      slidesToScroll,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: this.props.showDots || false,
      arrows: false,
      swipeToSlide: false,
      autoplay: false,
      draggable: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
      beforeChange: (current, next) => {
        if (!isWapView) {
          this.changeTabs(
            isWapView ? states[next] : getSubsetByIndex(states, next),
            false,
          );
        } else if (isWapView) {
          this.changeTabs([states[next]], false);
        }
      },
    };
    const isTabActive =
      (states && isWapView && states.length > 1) ||
      (states && !isWapView && states.length > 3);
    return (
      <>
        {isTabActive && (
          <div className={`${s.tabListWrap} adtabsset`}>
            <ErrorBoundary>
              <CapsuleTabList
                list={states}
                currentActiveTab={currentActiveTab}
                tabRefs={this.tabRefs}
                changeTabs={this.changeTabs}
                isWapView={isWapView}
                cat="key"
              />
            </ErrorBoundary>
            {wgtclient !== 'AMP' && (
              <AdCaller data={{ jname: 'result_second' }} immediateLoad />
            )}
          </div>
        )}
        {!isTabActive &&
          wgtclient !== 'AMP' && (
            <AdCaller data={{ jname: 'result_second' }} immediateLoad />
          )}
        <div
          className={`${s.electionContainer} ${
            this.props.showDots ? 'slick_UI' : ''
          }`}
        >
          <Slider
            ref={slider => {
              this.slider = slider;
            }}
            {...settings}
          >
            {states &&
              states.length > 0 &&
              states.map(state => (
                <ErrorBoundary>
                  <ElectionStatusCard
                    key={state.name}
                    isExitPoll={isExitPoll}
                    config={state}
                    data={electionData[state.key]}
                    sortedData={sortedData && sortedData[state.key]}
                    isWapView={isWapView}
                    setAlliancePopUpData={this.setAlliancePopUpData}
                    starCandidateData={
                      starCandidateData && starCandidateData[state.key]
                    }
                    hideStarCandidate={hideStarCandidate}
                    hideLiveblog={hideLiveblog}
                    hideETheading={hideETheading}
                    hideLink={hideLink}
                    hideHeading={hideHeading}
                    hideShare={hideSharing}
                    numberOfStates={states.length}
                    hideBattle={hideBattle}
                    wgtclient={wgtclient}
                    infoMsgClass={state.className}
                    electionwdtWap={electionwdtWap}
                    noTopRadius={
                      this.props.isWapView && !(hideETheading && hideHeading) // condition to render MainHeader should also be met
                    }
                    isHomePage={this.props.isHomePage}
                    hideTitleBar={hideTitleBar}
                    threeDViewBanner={threeDViewBanner}
                    page={page}
                  />
                </ErrorBoundary>
              ))}
          </Slider>
          {/* {!hideLink &&
            !isExitPoll && (
              <div className={s.viewFullCoverage}>
                <Morebtn
                  moreText="Complete Coverage"
                  moreLink={path || '/elections/assembly-elections/results'}
                  redBrdr
                />
              </div>
            )} */}
          {isWapView &&
            showAlliancePopup && (
              <ErrorBoundary>
                <PopupPortal usePopupPortal>
                  <AlliancePopup
                    allianceMap={allianceMap}
                    toggleAllianceInfoPopup={this.toggleAllianceInfoPopup}
                  />
                </PopupPortal>
              </ErrorBoundary>
            )}
        </div>
      </>
    );
  };

  render() {
    const {
      isWapView,
      hideSharing,
      hideLiveblog,
      hideHeading,
      hideInfocus,
      hideETheading,
      isExitPoll,
      bgColor,
      bgColorOuter,
      ettxt,
      liveblog,
      keywords,
      states = [],
      displaytext,
      hideDisplayText,
      datasource,
      path,
      shareTitle,
      isPowerByAd,
      isPowerByAdActive,
      hideLink,
      breakingnews,
      refreshinterval,
      hideStarCandidate,
      isPrime,
    } = this.props;

    if (!refreshinterval) {
      return null;
    }

    const backGroundStyle = bgColor ? `#${bgColor}` : '';

    const backGroundStyleOuter = bgColorOuter ? `#${bgColorOuter}` : '';

    const inpageminitv = this.props?.inpageminitv === '1';
    const minitvPrimeObj = {};
    if (isPrime) {
      minitvPrimeObj.isAdActive = 1;
    }
    return (
      <div className={`${`election_widget`}`} ref={this.ref}>
        <div
          className={`${s.electionWidget} globalElectionWidget`}
          style={{ backgroundColor: backGroundStyleOuter }}
        >
          {this.props.isWapView &&
            !isExitPoll &&
            !hideLiveblog &&
            liveblog && (
              <div className={`${s.liveBlogCapsuleWrap}`}>
                <ErrorBoundary>
                  <LiveblogUpdates
                    isWapView={isWapView}
                    liveblogData={liveblog}
                    storiesCount={1}
                    liveBlogCapsule
                    ga4Data={[
                      {
                        event: 'user_click',
                        type: 'exitpoll_widget',
                        label: 'view_more_update',
                      },
                    ]}
                  />
                </ErrorBoundary>
              </div>
            )}
          {isWapView &&
            !hideStarCandidate &&
            inpageminitv &&
            !isExitPoll && (
              <ErrorBoundary>
                <WithMiniTv
                  isWapView
                  isSticky={false}
                  mwebfullview
                  containerClass="minitvMwebFullView livemtv"
                  layoutConfig={{
                    marker: '',
                    skipPrime: false,
                  }}
                />
              </ErrorBoundary>
            )}
          {!(hideETheading && hideHeading) && (
            <ErrorBoundary>
              <div className={s.mainHeaderWrap}>
                <MainHeader
                  hideETheading={hideETheading}
                  ettxt={ettxt}
                  displaytext={displaytext}
                  isPowerByAd={isPowerByAd}
                  hideLink={hideLink}
                  shareTitle={shareTitle}
                  path={path}
                  hideHeading={hideHeading}
                  hideSharing={hideSharing}
                  isPowerByAdActive={isPowerByAdActive}
                  breakingnews={breakingnews}
                  isWapView={isWapView}
                  hideDisplayText={hideDisplayText}
                />
              </div>
            </ErrorBoundary>
          )}
          <div
            style={{ backgroundColor: backGroundStyle }}
            className={s.electionInner}
          >
            {
              <div>
                <div
                  className={`${s.twoColumn} ${
                    states && states.length === 1 && !isWapView
                      ? `${s.singleStateElection}`
                      : ''
                  } globalTwoColumn`}
                >
                  <div className={s.left}>
                    {states && states.length > 0 && this.renderElectionstate()}
                  </div>
                  {!isWapView &&
                    !hideLiveblog && (
                      <div className={`${s.right} boxStyle`}>
                        {/* hideStarCandidate - To show minitv on home page only  */}
                        {inpageminitv &&
                          !hideStarCandidate &&
                          !isExitPoll && (
                            <ErrorBoundary>
                              <WithMiniTv
                                containerClass={s.miniTvWrap}
                                isWapView={false}
                                isInPageDock
                                layoutConfig={{
                                  marker: '',
                                  skipPrime: false,
                                  ...minitvPrimeObj,
                                }}
                              />
                            </ErrorBoundary>
                          )}
                        {states &&
                          liveblog &&
                          !hideLiveblog && (
                            <ErrorBoundary>
                              <LiveblogUpdates
                                isWapView={isWapView}
                                liveblogData={liveblog}
                                storiesCount={liveblog?.storyCount || 1}
                                ga4Data={[
                                  {
                                    event: 'user_click',
                                    type: 'exitpoll_widget',
                                    label: 'view_more_update',
                                  },
                                ]}
                              />
                            </ErrorBoundary>
                          )}
                      </div>
                    )}
                </div>
              </div>
            }
            {this.props.isWapView &&
              isExitPoll &&
              !hideLiveblog &&
              liveblog && (
                <div className={`${s.mobileLiveBlog}`}>
                  <ErrorBoundary>
                    <LiveblogUpdates
                      isWapView={isWapView}
                      liveblogData={liveblog}
                      storiesCount={1}
                      ga4Data={[
                        {
                          event: 'user_click',
                          type: 'exitpoll_widget',
                          label: 'view_more_update',
                        },
                      ]}
                    />
                  </ErrorBoundary>
                </div>
              )}
            {!isExitPoll &&
              datasource && (
                <span
                  className={`${s.sourceText1} ${!hideETheading ? s.hide : ''}`}
                >
                  {datasource}
                </span>
              )}
            {keywords &&
              !hideInfocus &&
              Array.isArray(keywords.items) &&
              Array.isArray(keywords.items[0]) && (
                <div
                  className={`light_capsul ${keywords.className} ${
                    isWapView ? s.inFocusWrapper : ''
                  }`}
                >
                  {!isWapView ? (
                    <ErrorBoundary>
                      <LinksList
                        cssSelector={
                          keywords.id === 'infocus2'
                            ? 'link_list_light'
                            : 'hptrendinglist'
                        }
                        sectionData={{
                          ...keywords,
                          items: keywords.items.flat(),
                        }}
                        key={keywords.id}
                      />
                    </ErrorBoundary>
                  ) : (
                    <ErrorBoundary>
                      <LinksListMobile
                        cssSelector={
                          keywords.id === 'infocus2'
                            ? 'link_list_light'
                            : 'hptrendinglist'
                        }
                        heading={keywords.heading}
                        sectionData={{
                          ...keywords,
                          items: keywords.items.flat(),
                        }}
                        key={keywords.id}
                      />
                    </ErrorBoundary>
                  )}
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  refreshinterval: state?.electionV2?.refreshinterval,
  electionData: state?.electionV2?.electionData,
  starCandidateData: state?.electionV2?.starCandidateData,
  isExitPoll: state?.electionV2?.isExitPoll,
  displaytext: state?.electionV2?.displaytext,
  keywords: state?.electionV2?.keywords,
  breakingnews: state?.electionV2?.breakingnews,
  states: state?.electionV2?.states,
  liveblog: state?.electionV2?.liveblog,
  datasource: state?.electionV2?.datasource,
  hideexitheading: state?.electionV2?.hideexitheading,
  path: state?.electionV2?.path,
  shareTitle: state?.electionV2?.shareTitle,
  exitPollStateData: state?.electionV2?.exitPollStateData,
  sortedData: state?.electionV2?.sortedData,
  result: state?.electionV2?.result,
  inpageminitv: state?.electionV2?.inpageminitv,
  isPrime: state?.isPrime,
  threeDViewBanner: state?.electionV2?.threeDViewBanner,
});

const mapDispatchToProps = dispatch => ({
  fetchElectionData: data => {
    dispatch(loadElectionData(data));
  },
});

ElectionWrapper.propTypes = {
  isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
  isExitPoll: PropTypes.bool,
  hideETheading: PropTypes.bool,
  hideExitHeading: PropTypes.bool,
  bgColor: PropTypes.string,
  hideSharing: PropTypes.bool,
  bgColorOuter: PropTypes.string,
  isPowerByAd: PropTypes.shape({}),
  isPowerByAdActive: PropTypes.number,
  showDots: PropTypes.bool,
  ettxt: PropTypes.string,
  hideDisplayText: PropTypes.bool,
  electionwdtWap: PropTypes.bool,
  isPrime: PropTypes.bool,
  isHomePage: PropTypes.bool,
};
ElectionWrapper.defaultProps = {
  isWapView: false,
  data: {},
  isExitPoll: false,
  hideETheading: false,
  hideExitHeading: false,
  hideSharing: false,
  bgColor: '',
  bgColorOuter: '',
  isPowerByAd: null,
  isPowerByAdActive: 0,
  showDots: false,
  hideDisplayText: false,
  electionwdtWap: false,
  isPrime: false,
  ettxt: '',
  isHomePage: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(ElectionWrapper);
